module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('icon', {
    class: {
      'notificationsIcon': true,
      'notificationsIcon__info-blue': _vm.isInfo,
      'notificationsIcon__success-green': _vm.isSuccess,
      'notificationsIcon__warning-yellow': _vm.isWarning,
      'notificationsIcon__error-red': _vm.isError
    },
    attrs: {
      "name": _vm.name,
      "scale": "1"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f78e89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/notifications/NotificationIcon.vue
// module id = 1864
// module chunks = 0